//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver } from 'vee-validate'
import { FormCheckBox, FormInput } from '@/components/Form'
import Finder from '~/components/Shared/Finder/Finder.vue'
import { showErrorNotification } from '~/util/notifications'
export default {
  components: {
    ValidationObserver,
    Finder,
    FormCheckBox,
    FormInput,
  },
  props: {
    countryId: {
      type: Number,
      required: true,
    },
  },
  async fetch() {
    this.defaultCities = await this.$repository.location.findCitiesByCountry({
      countryId: this.countryId,
      term: '',
    })
  },
  data() {
    return {
      form: {
        identification_number: null,
        education: null,
        city: null,
        password: null,
        confirmation: null,
        terms: undefined,
        provide_data: undefined,
        subscribed: false,
      },
      term: '',
      defaultCities: [],
    }
  },
  watch: {
    form: {
      handler(val) {
        this.form.terms = !this.form.terms ? undefined : true
        this.form.provide_data = !this.form.provide_data ? undefined : true
      },
      deep: true,
    },
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.registerForeignFormObserver.validate()
      if (!isValid) {
        const errors = this.$refs.registerForeignFormObserver.errors
        const formattedErrors = Object.values(errors)
          .flat()
          .map((error) => error.charAt(0).toLowerCase() + error.slice(1))
          .join(', ')
        const errorMessage =
          formattedErrors.charAt(0).toUpperCase() + formattedErrors.slice(1)
        showErrorNotification(this, errorMessage, 5000)
        return
      }
      this.$emit('register', this.form)
    },
    selectCity(city) {
      this.form.city = city
    },
    async searchCities(term) {
      const foundedCities = await this.$repository.location.findCitiesByCountry(
        {
          countryId: this.countryId,
          term,
        }
      )
      return foundedCities
    },
    showTerms() {
      this.$emit('show-terms')
    },
    showPolicyData() {
      this.$emit('show-policy-data')
    },
  },
}
